'use strict';

// capture and report performance timing information of page loading process
module.exports = function capturePerfTiming(pageManager) {
    var cfgManager = pageManager.cfgManager;
    var catchPage = cfgManager.get('autoCatch').page;
    var pageConfig = cfgManager.get('page');

    if (catchPage && pageConfig.sensoryIndex) {
        pageManager.sensoryObserver();
    } else {
        try {
            // disconnect MutationObserver created in pre-catch module
            if (window._Owl_ && window._Owl_.observer && window._Owl_.observer.disconnect) {
                window._Owl_.observer.disconnect();
            }
        } catch (e) {}
    }

    if (catchPage && !pageManager.getReady()) {
        pageManager.setInitConfig();
        if (document && document.readyState === 'complete') {
            pageManager.parsePageTimeWithDefer();
        } else {
            var ADD_EVENT_FUNC = window.addEventListener || window.attachEvent;
            var loadName = window.addEventListener ? 'load' : 'onload';
            ADD_EVENT_FUNC(loadName, function () {
                pageManager.parsePageTimeWithDefer();
            });
        }
    }
};